import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            电影<span className="text-accent-500">分类</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            按类型浏览，快速找到你喜欢的欧美大片
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 md:p-8 bg-background-50 rounded-lg border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 group-hover:text-accent-600 transition-colors duration-200">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 hidden sm:block">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}